module.exports = __webpack_public_path__ + "img/arh_2.d16d64af.png";